import React from 'react';

const ResponsiveImg = ({ mobileSrc, desktopSrc, alt = '' }) => {
	return (
		<picture>
			<source media="(min-width: 600px)" srcSet={desktopSrc} />
			<source media="(max-width: 599px)" srcSet={mobileSrc} />
			<img className="o-fluid-img" srcSet={desktopSrc} alt={alt} loading="lazy" style={{ margin: '40px 0' }} />
		</picture>
	);
};

export default ResponsiveImg;
